/**
 * This file is to map trigger, from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { TriggerEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import {
	getEdge,
	getValudOfVariable,
} from "../../../../../containers/editor/utils/utils";

const getShadows = (condition) => {
	let shadows = [];
	let varValue;
	if (condition.or) {
		varValue = getValudOfVariable(
			condition.or[condition.or.length - 1].eq?.var
		).replace("input.data.step in ", "");

		if (varValue[0] !== "[") return false;
		shadows = JSON.parse(varValue).filter((v) => !v.includes("_loop"));
	}
	return shadows;
};

/**
 *
 * @param {*} audience
 */
const parseBEContactTaggedToFE = (
	trigger,
	nextSubAutomation,
	nextStepCondition,
	nextType,
	index
) => {
	let shadows = [];
	if (nextStepCondition) {
		shadows = getShadows(nextStepCondition);
	}
	const id = `event_${+new Date()}${index}`;
	const triggerEvent = {
		id: id,
		type: "editorNode",
		data: {
			tags: trigger.args.tag != "" ? [trigger.args.tag] : [],
			baseId: "contactTagged",
			...(trigger.args.list_id && { audience: trigger.args.list_id }),
			id: id,
			...TriggerEvents()[1],
			initialElement: true,
			shadows: shadows,
			tagAction:
				trigger.name == "Contact.Tagged"
					? "tag"
					: trigger.name == "Contact.Untagged"
						? "untag"
						: "",
		},
	};
	const firstTargetId = nextSubAutomation.id;
	const links = getEdge("branchingEdge", triggerEvent.id, firstTargetId);
	return {
		events: [triggerEvent],
		links: [links],
	};
};
const parseFEContactTaggedToBE = (FEEvent, events) => {
	return {
		args: {
			tag: FEEvent.data.tags.length > 0 ? FEEvent.data.tags[0] : "",
			...(FEEvent.data?.audience && { list_id: FEEvent.data.audience })
		},
		name:
			FEEvent.data.tagAction == "tag"
				? "Contact.Tagged"
				: FEEvent.data.tagAction == "untag"
					? "Contact.Untagged"
					: "",
	};
};
export { parseBEContactTaggedToFE, parseFEContactTaggedToBE };
